export const interests = [
  "Full time",
  "Freelance",
  "Internships",
  "Collaborations"
];
